import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'
import { SAVE_SELECTED_YEAR_SUCCESS } from '../actions/_actionTypes'

// Attention case should be respected
export default function yearReducer(state = initialState.selectedYear, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_YEAR_SUCCESS:
      return action.selectedYear;
    default:
      return state;
  }
}
